import React from 'react';
import { TweenMax } from 'gsap';
import { navigate } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './style.module.scss';

const ResultCell = ({ item, resource, clearSearchResults }) => {

    let arrowRef = null;
    const onMouseEnter = (id) => {
        TweenMax.to(arrowRef, 0.2, { x: 10 })
    }

    const onMouseLeave = (id) => {
        TweenMax.to(arrowRef, 0.2, { x: 0 })
    }

    const _navigateToItem = (resource, item) => {
        const resourceName = resource.slice(0, -1);
        clearSearchResults();
        navigate(`/single-${resourceName}?id=${item.id}`);
    };

    return (
        <div onMouseEnter={() => onMouseEnter()} onMouseLeave={() => onMouseLeave()} className={`${styles.ResourceItemContainer} ${styles.validResult}`}>
            <span onClick={() => _navigateToItem(resource, item)}>
                {item.name}  <span ref={r => arrowRef = r}><FontAwesomeIcon style={{ marginLeft: '1rem', fontSize: '1rem' }} icon={"arrow-right"} /></span>
            </span>
        </div>
    )
}

export default ResultCell;